import React, { useState } from "react";
import { Divider, MenuItem } from "@mui/material";
import StyledMenu from "../../../../components/layout/StyledMenu";
import { postNotification } from "../../../../components/utilities/Notifications";
import ExportModal from "../../../../components/modals/ExportModal";
import ProgressModal from "../../../../components/modals/ProgressModal";
import { useConfirm } from "material-ui-confirm";
import { BulkAddTestPlayersModal } from "./EventRosterModals";
import ModalLoadingMessage from "../../../../components/modals/ModalLoadingMessage";
import { postData } from "../../../../components/utilities/UtilityFunctions";
import { refreshRoster } from "../EventFunctions";

export function OptionsMenu(props) {
  const {
    anchorEl,
    setAnchorEl,
    setLoading,
    event,
    authContext,
    setBulkAddOpen,
    setBulkAddEmailsOpen,
    players,
    setRefreshPlayers,
  } = props;

  const [testPlayersModal, setTestPlayersModal] = useState(false);
  const [rosterModal, setRosterModal] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(null);
  const [progress, setProgress] = useState(null);
  const confirm = useConfirm();
  const open = Boolean(anchorEl);
  return (
    <>
      <StyledMenu
        id="options-menu"
        MenuListProps={{
          "aria-labelledby": "options-button",
        }}
        disableScrollLock
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={async (e) => {
            setRosterModal(true);
            setAnchorEl(null);
          }}
          disableRipple
        >
          Export Roster
        </MenuItem>
        {
          <MenuItem
            onClick={async (e) => {
              setLoading(true);

              try {
                await postData(`/events/${event.id}/sendListUploadRequest`, {
                  body: {
                    email: authContext?.authState?.identity?.email,
                  },
                });

                postNotification("success", "Upload emails have been sent");
              } catch (err) {
                postNotification("error", err);
              }

              setLoading(false);
              setAnchorEl(null);
            }}
            disableRipple
          >
            Send {event?.gameSystem?.listLabel || "List"} Upload Emails
          </MenuItem>
        }

        <MenuItem
          onClick={async (e) => {
            setAnchorEl(null);
            var perc = 0;
            var notCheckedIn = players?.filter(
              (player) => !player.checkedIn && !player.dropped
            );
            if (!notCheckedIn?.length) {
              postNotification("warning", "There are no players to check in");
              return;
            }
            try {
              await confirm({
                title: `Are you sure?`,
                description:
                  "Are you sure you wish to check in all non dropped players?",
                dialogProps: {
                  sx: {
                    zIndex: 99999,
                  },
                },
                confirmationText: "Yes",
                cancellationText: "No",
              });
            } catch (err) {
              return;
            }

            setProgress(0);
            setProcessing(true);

            try {
              var step = 100 / notCheckedIn?.length;
              for (let player of notCheckedIn) {
                await postData(
                  `/${
                    event?.teamEvent || event?.doublesEvent
                      ? "teamplayers"
                      : "players"
                  }/${player?.id}`,
                  {
                    body: {
                      set: { checkedIn: true },
                    },
                  }
                );

                perc += step;
                setProgress(perc < 1 ? 1 : perc);
              }

              postNotification(
                "success",
                "All non dropped players have been checked in"
              );
            } catch (err) {
              postNotification("error", err);
            }
            if (perc !== 0) {
              setRefreshPlayers(true);
            }
            setProcessing(false);
            setProgress(null);
          }}
          disableRipple
        >
          Check In All Players
        </MenuItem>

        <Divider
          sx={{
            mt: 2,
            mb: 2,
          }}
        />

        <MenuItem
          onClick={async () => {
            setAnchorEl(null);
            var perc = 0;
            var checkedIn = players?.filter(
              (player) => player.checkedIn && !player.dropped
            );
            if (!checkedIn?.length) {
              postNotification("warning", "There are no players to check out");
              return;
            }
            try {
              await confirm({
                title: `Are you sure?`,
                description:
                  "Are you sure you wish to check out all non dropped players?",
                dialogProps: {
                  sx: {
                    zIndex: 99999,
                  },
                },
                confirmationText: "Yes",
                cancellationText: "No",
              });
            } catch (err) {
              return;
            }

            setProgress(0);
            setProcessing(true);

            try {
              var step = 100 / checkedIn?.length;
              for (let player of checkedIn) {
                if (event?.teamEvent || event?.doublesEvent) {
                  await postData(`/teamplayers/${player?.id}`, {
                    body: {
                      set: { checkedIn: false },
                    },
                  });

                  if (player?.players && player?.players?.length) {
                    for (let singlePlayer of player?.players) {
                      if (!singlePlayer?.dropped) {
                        await postData(`/players/${singlePlayer?.id}`, {
                          body: {
                            set: { checkedIn: false },
                          },
                        });
                      }
                    }
                  }
                } else {
                  await postData(`/players/${player?.id}`, {
                    body: {
                      set: { checkedIn: false },
                    },
                  });
                }

                perc += step;
                setProgress(perc < 1 ? 1 : perc);
              }

              postNotification(
                "success",
                "All non dropped players have been checked out"
              );
            } catch (err) {
              postNotification("error", err);
            }
            if (perc !== 0) {
              setRefreshPlayers(true);
            }
            setProcessing(false);
            setProgress(null);
          }}
          disableRipple
        >
          Check Out All Players
        </MenuItem>

        {authContext?.authState?.identity?.isAdmin === true && (
          <MenuItem
            onClick={async (e) => {
              setBulkAddOpen(true);
              setAnchorEl(null);
            }}
            disableRipple
          >
            Bulk Add Players
          </MenuItem>
        )}
        {authContext?.authState?.identity?.isAdmin === true && (
          <MenuItem
            onClick={async (e) => {
              setBulkAddEmailsOpen(true);
              setAnchorEl(null);
            }}
            disableRipple
          >
            Bulk Add Players via Email List
          </MenuItem>
        )}
        {authContext?.authState?.identity?.isAdmin === true && (
          <MenuItem
            onClick={async (e) => {
              setTestPlayersModal(true);
              setAnchorEl(null);
            }}
            disableRipple
          >
            Add Test Players
          </MenuItem>
        )}

        {authContext?.authState?.identity?.isAdmin === true && (
          <Divider
            sx={{
              mt: 2,
              mb: 2,
            }}
          />
        )}
        <MenuItem
          onClick={() => {
            refreshRoster();
          }}
        >
          Refresh Roster
        </MenuItem>
      </StyledMenu>
      <ExportModal
        label="Export Roster"
        exportTypes={["roster"]}
        event={event}
        setLoading={setLoading}
        open={rosterModal}
        setOpen={setRosterModal}
        authContext={authContext}
      />
      {authContext?.authState?.identity?.isAdmin === true && (
        <BulkAddTestPlayersModal
          open={testPlayersModal}
          setOpen={setTestPlayersModal}
          event={event}
          setRefreshPlayers={setRefreshPlayers}
          setLoadingMessage={setLoadingMessage}
        />
      )}
      <ProgressModal
        open={processing}
        value={progress}
        message="Players Checked In"
      />
      {loadingMessage && (
        <ModalLoadingMessage
          open={Boolean(loadingMessage)}
          message={loadingMessage}
        />
      )}
    </>
  );
}

export function FiltersMenu(props) {
  const {
    anchorEl,
    setAnchorEl,
    event,
    players,
    setFilteredPlayers,
    filterType,
    setFilterType,
  } = props;

  const open = Boolean(anchorEl);

  return (
    <>
      <StyledMenu
        id="filters-menu"
        MenuListProps={{
          "aria-labelledby": "filters-button",
        }}
        disableScrollLock
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          selected={filterType === "" ? true : false}
          onClick={async (e) => {
            setFilterType("");
            setAnchorEl(null);
          }}
          disableRipple
        >
          All {event?.teamEvent ? "Teams" : "Players"}
        </MenuItem>

        <Divider
          sx={{
            mt: 2,
            mb: 2,
          }}
        />

        <MenuItem
          selected={filterType === "Checked In" ? true : false}
          onClick={async (e) => {
            setFilterType("Checked In");
            setAnchorEl(null);
          }}
          disableRipple
        >
          Checked In {event?.teamEvent ? "Teams" : "Players"}
        </MenuItem>

        <MenuItem
          selected={filterType === "Not Checked In" ? true : false}
          onClick={async (e) => {
            setFilterType("Not Checked In");
            setAnchorEl(null);
          }}
          disableRipple
        >
          Not Checked In {event?.teamEvent ? "Teams" : "Players"}
        </MenuItem>

        <Divider
          sx={{
            mt: 2,
            mb: 2,
          }}
        />

        <MenuItem
          selected={filterType === "Lists" ? true : false}
          onClick={async (e) => {
            const newList = players?.filter((player) => player?.armyListText);
            setFilteredPlayers(newList);
            setFilterType("Lists");

            setAnchorEl(null);
          }}
          disableRipple
        >
          {event?.doublesEvent || event?.teamEvent ? "Teams" : "Players"} With{" "}
          {event?.gameSystem?.listLabel || "List"}s
        </MenuItem>
        <MenuItem
          selected={filterType === "No Lists" ? true : false}
          onClick={async (e) => {
            setFilterType("No Lists");
            setAnchorEl(null);
          }}
          disableRipple
        >
          {event?.doublesEvent || event?.teamEvent ? "Teams" : "Players"}{" "}
          Without {event?.gameSystem?.listLabel || "List"}s
        </MenuItem>

        <Divider
          sx={{
            mt: 2,
            mb: 2,
          }}
        />

        <MenuItem
          selected={filterType === "Dropped" ? true : false}
          onClick={async (e) => {
            setFilterType("Dropped");
            setAnchorEl(null);
          }}
          disableRipple
        >
          Dropped {event?.teamEvent ? "Teams" : "Players"}
        </MenuItem>

        <MenuItem
          selected={filterType === "Not Dropped" ? true : false}
          onClick={async (e) => {
            setFilterType("Not Dropped");
            setAnchorEl(null);
          }}
          disableRipple
        >
          Not Dropped {event?.teamEvent ? "Teams" : "Players"}
        </MenuItem>
      </StyledMenu>
    </>
  );
}
